<template>
  <div class="meta-row">
    <button
      v-if="
        (!isActiveSoloCarta || isAdmin) && getCartProductQty(drink) && !isCubata
      "
      type="button"
      class="order-button remove-product"
      @click="removeOneFromCart(drink)"
    >
      <font-awesome-icon
        icon="minus-square"
        :style="{ color: '#ea2222', fontSize: 20 }"
      />
    </button>

    <div v-if="size !== 'base'" class="product-size">{{ size }}</div>

    <button
      v-if="(!isActiveSoloCarta || isAdmin) && !isOnlyMenu"
      type="button"
      class="order-button add-product"
      @click="addToCart(drink)"
    >
      <font-awesome-icon
        icon="plus-square"
        :style="{ color: '#11bd11', fontSize: 20 }"
      />
    </button>

    <span v-if="getCartProductQty(drink)" class="cart-quantity"
      >{{ getCartProductQty(drink) }}x</span
    >
    <div class="product-price" :style="{ color: listItemPriceColorTheme }">
      {{ formatPriceDrink(drink) }}
    </div>

    <IngredienteDialog ref="ingredienteDialog"></IngredienteDialog>
    <QrValidationModal
      :check-q-r="checkQR"
      @closeQrValidationModal="closeQrValidationModal"
      :isAdmin="isAdmin"
    ></QrValidationModal>
    <email-modal ref="emailModalRef"></email-modal>
  </div>
</template>

<script>
import IngredienteDialog from "@/components/public/products/SelectItems/IngredienteDialog";
import QrValidationModal from "@/components/public/modals/QrValidationModal";
import EmailModal from "@/components/public/modals/EmailModal.vue";
const NO_QR = "NO QR";

export default {
  name: "add-to-cart-drink",
  props: ["drink", "size", "isAdmin"],
  components: {
    QrValidationModal,
    IngredienteDialog,
    EmailModal
  },
  data() {
    return {
      checkQR: false
    };
  },
  computed: {
    tableQR() {
      return !this.isAdmin
        ? this.$store.state.tableQR
        : this.$store.state.adminTableQR;
    },
    isCubata() {
      return this.size === "cubata";
    },
    getEmail() {
      return this.$store.getters.getEmail(this.isAdmin);
    }
  },
  methods: {
    getCartProductQty(product) {
      const { cart, admincart } = this.$store.state;
      const order = this.getOrder(product, this.size);
      return this.getCartProductQuantity(
        this.isAdmin ? admincart : cart,
        order
      );
    },
    removeOneFromCart(product) {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }

      const order = this.getOrder(product, this.size);
      if (!this.isAdmin) {
        this.$store.commit("removeOneFromCart", {
          order: order,
          size: this.size,
          update: true,
          product: product
        });
      } else {
        this.$store.commit("removeOneFromCart", {
          order: order,
          size: this.size,
          update: true,
          product: product,
          cart_type: "admin"
        });
      }
    },
    addToCart(product) {
      console.log("product", product);
      let email = this.getEmail;

      console.log("email", email);
      if (!email) {
        this.$refs.emailModalRef.open();
        return;
      }
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }

      // check cart item length is greater then 20
      const { cart } = this.$store.state;
      const { admincart } = this.$store.state;
      if (cart.length >= 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }
      if (this.isAdmin && admincart.length >= 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }
      let item;

      item = {
        price: this.getPriceBySize(product, this.size),
        name: product.name,
        product_id: product.id,
        product_type_id: product.product_type_id,
        quantity: 1,
        size: this.size,
        order: this.getOrder(product, this.size),
        notes: "",
        stripeProduct: null,
        stripeSku: null,
        category_id: product.category_id,
        tableQR: this.tableQR,
        priceType: "unit",
        weight: null,
        email: email,
        isAllowComment: product.isAllowComment,
        isPrinted: false,
        isDelivered: false,
        trans: product.trans
          ? product.trans
          : {
              name: {
                en: product.name,
                es: product.name,
                de: product.name,
                fr: product.name,
                it: product.name
              }
            }
      };

      if (this.isCubata) {
        this.$store.commit("toggleItemListModal", item);
        return;
      }

      if (
        product.hasMainIngredient &&
        product.ingredients &&
        product.ingredients.length &&
        product.price_cubata === null &&
        product.price_cup === null &&
        product.price_shot === null
      ) {
        this.isAdmin ? (item.cart_type = "admin") : item;
        this.$refs.ingredienteDialog.open(
          item,
          product.ingredients,
          product.numberOfIngredients
        );
        return;
      }

      item.order_translations = {
        en: this.translateToOneLang("name", product, "en"),
        es: this.translateToOneLang("name", product, "es"),
        de: this.translateToOneLang("name", product, "de"),
        fr: this.translateToOneLang("name", product, "fr"),
        it: this.translateToOneLang("name", product, "it")
      };

      if (!this.isAdmin) {
        this.$store.commit("addToCart", { item: item, update: true });
        this.$store.dispatch("addStripeProductToCart", item);
      } else {
        item.cart_type = "admin";
        this.$store.commit("addToCart", { item: item, update: false });
        this.$store.dispatch("addStripeProductToCart", item);
      }
      this.$forceUpdate(); // Force update to fetch cart data (for displaying the new quantity)
    },
    formatPriceDrink(product) {
      const number = this.getPriceBySize(product, this.size);
      return this.formatPrice(number);
    },
    closeQrValidationModal() {
      this.checkQR = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
